import { Injectable } from '@angular/core';

import { apiName } from "./data.service";
import { RestService } from "../../../core/services/rest.service";
import { ModeloGps } from "./modelo-gps.model";

@Injectable()
export class ModeloGpsApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: ModeloGps, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: ModeloGps, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"modelo"};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        let filter: any = {};
        this._restService.onGetPostId(apiName, objectId, filter, done);
    }

    onGetApiUrl() {
        return apiName;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/modelos-gps/shared/modelo-gps-api.service.ts
 **/